import(/* webpackMode: "eager", webpackExports: ["LiveCompactFeed"] */ "/app/apps/web/components/feed/live-compact-feed.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/cache/client-cache-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/config/client-config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StrokeplayLeaderboard"] */ "/app/packages/ui/components/table/leaderboard/strokeplay-leaderboard.tsx");
